import { isBrowser } from 'browser-or-node';
import { whitelistedEnvVars } from 'shared/whitelisted-env-vars';
import { decodeComplianceConfig } from 'shared/core/helpers/compliance-serialization';
/**
 * @param {string} key
 * @param {string|undefined} value
 * @returns {string}
 */ function getRequired(key, value) {
    if (!value && process.env.NODE_ENV !== 'test') {
        // TODO: make an Error when test envs set these vars
        console.warn("Required PublicEnv var ".concat(key, " is not set"));
    }
    return value;
}
var _ref;
// If we're in the browser, these values will come from /api/config.js and be attached to the window.
// Otherwise, we're doing server rendering, so we have direct access to the environment variables.
// Note: When setting up a new application you will need to have a script tag that loads these in,
// e.g <script src='/api/config.js' />
var values = (_ref = isBrowser ? window.reactEnv : whitelistedEnvVars) !== null && _ref !== void 0 ? _ref : {};
var PublicEnv = {
    // mandatory
    adminUrl: getRequired('ADMIN_URL', values.adminUrl),
    aerosyncConfigurationId: getRequired('AEROSYNC_CONFIGURATION_ID', values.aerosyncConfigurationId),
    amplitudeApiKey: getRequired('AMPLITUDE_API_KEY', values.amplitudeApiKey),
    apiUrl: getRequired('API_URL', values.apiUrl),
    appEnv: getRequired('APP_ENV', values.appEnv),
    basisTheoryKey: getRequired('BASIS_THEORY_KEY', values.basisTheoryKey),
    consumerConciergeMfRemoteUrl: getRequired('CONSUMER_CONCIERGE_MF_REMOTE_URL', values.consumerConciergeMfRemoteUrl),
    consumerUrl: getRequired('CONSUMER_URL', values.consumerUrl),
    googleAnalyticsID: 'UA-101536475-1',
    graphqlUri: "".concat(getRequired('API_URL', values.apiUrl), "/graphql"),
    launchDarklyClientId: getRequired('LAUNCH_DARKLY_CLIENT_ID', values.launchDarklyClientId),
    paysafeEnvironment: getRequired('PAYSAFE_ENVIRONMENT', values.paysafeEnvironment),
    pendoApiKey: getRequired('PENDO_API_KEY', values.pendoApiKey),
    plaidEnv: getRequired('PLAID_ENV', values.plaidEnv),
    plaidKey: getRequired('PLAID_KEY', values.plaidKey),
    pusherKey: getRequired('PUSHER_KEY', values.pusherKey),
    siftBeaconKey: getRequired('SIFT_BEACON_KEY', values.siftBeaconKey),
    streamKey: getRequired('STREAM_MESSAGING_KEY_ID', values.streamKey),
    stripeKey: getRequired('STRIPE_PKEY', values.stripeKey),
    turnstileSiteKey: getRequired('CF_TURNSTILE_SITE_KEY', values.turnstileSiteKey),
    // optional
    // Remote compliance config delivered by the API via react-env; decode the Infinity sentinels.
    complianceConfig: values.complianceConfig ? decodeComplianceConfig(values.complianceConfig) : undefined,
    isE2E: values.isE2E,
    currentVersion: values.currentVersion,
    // Explicit opt-in for the dev account picker (see DevAccountPicker). Off unless an
    // environment deliberately sets ENABLE_DEV_ACCOUNT_PICKER=true — never inferred from
    // appEnv, so it can't leak into demo/staging just because they aren't "production".
    enableDevAccountPicker: values.enableDevAccountPicker,
    gtmContainerKey: values.gtmContainerKey,
    launchDarklyBaseUri: values.launchDarklyBaseUri,
    launchDarklyStreamUri: values.launchDarklyStreamUri,
    launchDarklyEventsUri: values.launchDarklyEventsUri,
    logrocketIdAdmin: values.logrocketIdAdmin,
    logrocketIdCheckout: values.logrocketIdCheckout,
    logrocketIdMarketplace: values.logrocketIdMarketplace,
    vectorPersonalizeApiUrl: values.vectorPersonalizeApiUrl,
    zendeskAdminKey: values.zendeskAdminKey,
    zendeskMarketplaceKey: values.zendeskMarketplaceKey
};
export default PublicEnv;
